import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
export const getPeriodsToSkip = (meta) => {
    return parseInt(meta?.find((meta) => meta.key === SUBSCRIPTION_CONTRACT_META_KEY.PERIODS_TO_SKIP)?.value || "");
};
